import Person, { PersonModel } from '@/model/identity/Person'

export interface BoarderModel {
  id: number
  person: PersonModel,
  bankIdentificationCode: number,
  boarderGroupCollection: any
}

export default class Boarder implements BoarderModel {
  private constructor (
    readonly id: number,
    readonly person: Person,
    readonly bankIdentificationCode: number,
    readonly boarderGroupCollection: any
  ) {

  }

  public static createFromModel (data: Partial<BoarderModel>): Boarder {
    return new Boarder(
      data.id!,
      Person.createFromModel(data.person!),
      data.bankIdentificationCode!,
      data.boarderGroupCollection
    );
  }
}